export const getFileName = (fnMask, date = new Date()) => {
    let fn = fnMask;
    fn = fn.replace('{date}', getDate(date));
    fn = fn.replace('{time}', getTime(date));
    return fn;
};
const getDate = (date) => {
    return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}`;
};
const getTime = (date) => {
    return `${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`;
};
const pad = (num) => {
    return `0${num}`.slice(-2);
};
export const getFileType = (contentType = '/pdf') => {
    const type = contentType.split('/')[1] || 'pdf';
    return type === 'jpeg' ? 'jpg' : type;
};
//# sourceMappingURL=filename.js.map